import React, { useState } from 'react';
import Title from 'components/TitleWithIcon';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
// import CitizenIdentityDataResumen from './resumen';
import {useStyles} from 'pages/solicitudesExtranjero/solicitudesNuevas/SolicitudesEmpadronamiento/styles';
import {useStylesResume} from './styles';
import {Today, LocationOn, AccountCircle, Person, Wc, Description,  } from '@material-ui/icons';
import { AppBar, Toolbar, IconButton, Typography, Grid, Divider, Button, ListItemText, ListItemIcon, Chip, ListItem} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CitizenIdentityDataResumen from './resumen';
import {functions} from 'constants/index';
import FormFirmaElectronica from 'components/FormFirmaElectronica';
import Cancel from '@material-ui/icons/Cancel';
import DialogLoadingMessage from 'components/BackDrop';
import { showMessagePersonalizedPosition } from 'services/SweetAlert';
import ApiServices from 'services/ApiServices';
import MostrarPDFModal from 'components/PdfModal'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CitizenIdentityData(props) {
    const classes = useStyles();
    const classesResume = useStylesResume();
    const [loading, setLoading] = useState(false)
    const [showModalPDF, setShowModalPDF] = useState({open:false, base64:''})
    const descargarConstanciaReimpresionDeEmpadronamiento = async (data)  =>{
        props.userDataPadron.password = data
        setLoading(true)
        try {
            const response  = await ApiServices.constanciaEmpadronamiento.generarSolicitudReimpresionConstancia(props.userDataPadron)
            if(response.error!==null){
                showMessagePersonalizedPosition('error','Oopss!', response.error.message,'center')
            }else{            
                let getBase64 = response.data.base64.split('data:application/pdf;base64,')
                setShowModalPDF({open: true, base64: getBase64[1]})
                showMessagePersonalizedPosition('success','¡BIEN!', response.data.message,'center')
            }                   
        } catch (exception) {
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Oops! ',"Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
            }
            else {
                showMessagePersonalizedPosition('error', '¡Oops! ',"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
            }                
        }
        setLoading(false)
    }

    const cerrarModalPDF = () =>{
        setShowModalPDF({open: false, base64: ''})
    }
    return (
        <div>
            <Dialog  
                open={props.showCitizenIdentityData}
                maxWidth={"lg"}
                fullWidth
                // fullScreen
                TransitionComponent={Transition}
                keepMounted
                onClose={props.closeShowCitizenIdentityData}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={props.closeShowCitizenIdentityData} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                           DATOS DEL CIUDADANO
                        </Typography>
                        <Button autoFocus color="inherit" onClick={props.closeShowCitizenIdentityData}>
                            Cerrar
                        </Button>
                    </Toolbar>
                </AppBar>
                <Title title="Datos del ciudadano" icon={"/menu/Document.png"}/>
         
                <Grid item xs={12}>
                    <div className={classes.centerTitle}><Divider /> <strong>FOTO, FIRMA, HUELLA</strong> <Divider /></div>
                </Grid >
                <Grid item xs={12}>
                    <CitizenIdentityDataResumen citizenIdentityData={props.citizenIdentityData}/>
                </Grid > 
                <Grid container className={classesResume.marginBotton}>
                    <Grid item xs={12}>
                        <div className={classes.centerTitle}><Divider /> <strong>DATOS GENERALES DEL CIUDADANO</strong> <Divider /></div>
                    </Grid >
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem}>
                            <ListItemText className={classesResume.rootListItemText}  primary="Código Estado Padrón: " />
                            <ListItemIcon className={classesResume.colorIcon}><AccountCircle/></ListItemIcon>
                        </ListItem>
                    </Grid > 
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip}  label={props.citizenIdentityDataGeneral.padronData?.codStatus} />                                
                    </Grid >
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem}>
                            <ListItemText className={classesResume.rootListItemText}  primary="Nombre Estado Padrón: " />
                            <ListItemIcon className={classesResume.colorIcon}><AccountCircle/></ListItemIcon>
                        </ListItem>
                    </Grid > 
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip}  label={props.citizenIdentityDataGeneral.padronData?.nombreStatus} />                                
                    </Grid >
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem}>
                            <ListItemText className={classesResume.rootListItemText}  primary="Nombre completo: " />
                            <ListItemIcon className={classesResume.colorIcon}><AccountCircle/></ListItemIcon>
                        </ListItem>
                    </Grid > 
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip}  label={props.citizenIdentityDataGeneral.fullName} />                                
                    </Grid >
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem}>
                            <ListItemText className={classesResume.rootListItemText}  primary="Sexo: " />
                            <ListItemIcon className={classesResume.colorIcon} ><Wc/></ListItemIcon>
                        </ListItem>
                    </Grid >                
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip} label={props.citizenIdentityDataGeneral.gender}  /> 
                    </Grid >    
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem}>
                            <ListItemText className={classesResume.rootListItemText} primary="Fecha de Nacimiento: " />
                            <ListItemIcon className={classesResume.colorIcon}><Today/></ListItemIcon>
                        </ListItem>                
                    </Grid >                
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip} label={functions.dateFormatGeneral(props.citizenIdentityDataGeneral.dateOfBirth)}  />                                
                    </Grid >   
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem}>
                            <ListItemText className={classesResume.rootListItemText} primary="Lugar de Nacimiento: " />
                            <ListItemIcon className={classesResume.colorIcon}><LocationOn/></ListItemIcon>
                        </ListItem>                
                    </Grid >                
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip} label={props.citizenIdentityDataGeneral.birthPlace} />                                
                    </Grid >  
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem} >
                            <ListItemText className={classesResume.rootListItemText} primary="Nombre del Padre: " />
                            <ListItemIcon className={classesResume.colorIcon}><Person/></ListItemIcon>
                        </ListItem>                
                    </Grid >
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip}
                            label={props.citizenIdentityDataGeneral.fatherFullName}
                        />                                
                    </Grid >  
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem}>
                            <ListItemText className={classesResume.rootListItemText} primary="Nombre de la Madre: " />
                            <ListItemIcon className={classesResume.colorIcon}><Person/></ListItemIcon>
                        </ListItem>                
                    </Grid >                
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip}
                            label={props.citizenIdentityDataGeneral.motherFullName}
                        />                                
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <FormFirmaElectronica 
                        inputTitleProcess={'Ingrese Contraseña *'}
                        buttonTitleProcess={'Generar Constancia de Empadronamiento'}
                        buttonIconProcess={<Description />}
                        buttonProcess={descargarConstanciaReimpresionDeEmpadronamiento}
                        buttonTitleCancel={'Cerrar'}
                        esBotonPersonalizado={true}
                        buttonIconCancel={<Cancel />}
                        closeModal={props.closeShowCitizenIdentityData}
                        titleLoading={'Generando constancia de Empadronamiento ...'}
                    />                
                </Grid >      
                <DialogLoadingMessage open={loading} title={'Generando constancia de Empadronamiento ...'}/>
                <MostrarPDFModal open={showModalPDF.open} handleClose={cerrarModalPDF} 
                title={'CONSTANCIA DE REIMPRESIÓN DE INSCRIPCIÓN'}
                base64={showModalPDF.base64} DescargarPDF={''}
            />                
            </Dialog>
        </div>
    );
}